export function toSavedRepresentation({
    durationId,
    modeOfStudyId,
    modeOfDeliveryId,
    campusLocationId,
    theDeliveryInstitutionID,
    quercusCode,
    statusId,
    shortCourse
}) {
    return `{'durationId': '${durationId}', 'modeOfStudyId': '${modeOfStudyId}', 'modeOfDeliveryId': '${modeOfDeliveryId}', 'campusLocationId': '${campusLocationId}', 'theDeliveryInstitutionID': '${theDeliveryInstitutionID}', 'quercusCode': '${quercusCode}', 'statusId': '${statusId}', 'shortCourse': '${shortCourse}'}`;
}
